import { z } from "zod";

export const EntregaObraClienteReportGeralSchema = z.object({
    idEntregaObra: z.number().int().optional(),
    status: z.array(z.number().int().positive()).nullable().optional().default(null),
    idsCliente: z.array(z.number().int().positive()).nullable().optional().default(null),
    vistoria: z.array(z.number().int().positive()).nullable().optional().default(null),
    idsChecklist: z.array(z.number().int().positive()).nullable().optional().default(null),
    idsUnidade: z.array(z.number().int().positive()).nullable().optional().default(null),
    idsLocalVistoria: z.array(z.number().int().positive()).nullable().optional().default(null),
    dataDe: z.coerce.date().optional().nullable().default(null),
    dataAte: z.coerce.date().optional().nullable().default(null),

});

export type EntregaObraClienteReportGeralForm = z.infer<typeof EntregaObraClienteReportGeralSchema>;

export const defaultEntregaObraClienteReportGeralForm: Partial<EntregaObraClienteReportGeralForm> = {
};
